<template>
  <div class="activityCard">
    <div class="card" v-on:click="goToActivity()" v-bind:class="{'large': (size === 'large'), 'small': (size === 'small')}">
        <div class="cardImage" v-bind:class="{'large': (size === 'large'), 'small': (size === 'small')}" v-if="typeof activity.images !== 'undefined'">
            <div class="img" :style="`background-image: url(${activity.images.data[0].thumbnail_path})`"></div>
            <div class="basePrice" v-if="activity.base_price">{{t('from')}} {{activity.base_price}} € <span v-if="activity.is_priced_per_occurrence">/ {{t('group')}}</span></div>
            <!--img class="img-fluid" :src="activity.images.data[0].thumbnail_path"-->
        </div>

        <!--Card content-->
        <div class="card-block" v-bind:class="{'large': (size === 'large'), 'small': (size === 'small')}">

          <OverviewIcons :activity="activity" :with-shadow="true"></OverviewIcons>
          <!--Title-->
          <h4 class="card-title">{{activity.translations[language].name}}</h4>
          <!--Text-->
          <!--div><Stars count="4"></Stars> <small>(4)</small></div-->
          <p class="card-text">
            <DescriptionHeader v-if="headerIcons" :activity="activity"></DescriptionHeader>
            <div class="description">
              {{activity.translations[language].description}}
            </div>
          </p>
        </div>
        <!--/.Card content-->
      </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
// import Stars from '../Stars';
import OverviewIcons from './OverviewIcons';
import DescriptionHeader from './DescriptionHeader';

export default {
  name: 'ActivityCard',
  components: {
    // Stars,
    DescriptionHeader,
    OverviewIcons,
  },
  data() {
    return {
    };
  },
  props: {
    activity: { default: {} },
    size: { default: 'small' },
    headerIcons: { default: true },
  },
  methods: {
    goToActivity() {
    },
  },
  computed: {
    ...mapState({
      language: state => state.language,
    }),
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4";
@import "../../../static/MDB-PRO/sass/mdb/free/data/colors";
@import "../../assets/scss/variables";

.activityCard {
  cursor: pointer;
  color: #222;
}

.card, .card-block {
  min-height: 100%;
}

.card.large {
  overflow: auto;
}
.card.small {
  overflow: visible;
  min-width: 20em;
}


.location {
  font-weight: 500;
}

.cardImage {
  position: relative;
}

.cardImage.large {
  width: 33%; 
  float: left;
}
.card-block.large {
  width: 61%;
  float: left; 
}

.description {
  position:relative;
  max-height: 4.5em;
  overflow: hidden;
}
.description:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); 
}

.img {
  background-size: cover;
}

.cardImage.small .img {
  padding-top: 61%;
}
.cardImage.large {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 39%;
  height: 100%;
  .img {
    position: relative;
    height: 100%;

  }
}
.card-block.large {
 margin-left: 39%;
 .card-title {
    padding-right: 48px;
 }
}

.basePrice {
  background-color: $brand-primary;
  color: white;
  text-align: right;
  padding: 6px 12px;
  position: absolute;
  right: -6px;
  bottom: 16px;
  z-index: 1;
  font-size: 13px;
}

@media only screen and (max-width: map-get($grid-breakpoints, md)) {
  .card-title {
      font-size: 18px;
      line-height: 1.2;
  }

}
</style>



// WEBPACK FOOTER //
// ActivityCard.vue?273aa322